import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Habit, Frequency } from './challenge.model';

@Component({
    selector: 'app-habit-edit-modal',
    templateUrl: './habit-edit-modal.component.html',
    styleUrls: ['./habit-edit-modal.component.scss'],
    standalone: false
})
export class HabitEditModalComponent implements OnChanges {
  @Input() mode: 'create' | 'edit' = 'create';
  @Input() habit: Habit | null = null;
  @Input() existingCategories: string[] = [];
  @Input() archivedHabits: Habit[] = [];

  @Output() save = new EventEmitter<Habit | Omit<Habit, 'id' | 'createdAt'>>();
  @Output() archive = new EventEmitter<string>();
  @Output() unarchive = new EventEmitter<string>();
  @Output() hardDelete = new EventEmitter<string>();
  @Output() close = new EventEmitter<void>();

  form = { name: '', category: '', frequency: 'daily' as Frequency, target: 1 };
  showArchived = false;
  formError = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['habit']) {
      if (this.habit) {
        this.form = {
          name: this.habit.name,
          category: this.habit.category,
          frequency: this.habit.frequency,
          target: this.habit.target ?? 1
        };
      } else {
        this.form = { name: '', category: '', frequency: 'daily', target: 1 };
      }
      this.formError = '';
    }
  }

  doSave() {
    if (!this.form.name.trim()) { this.formError = 'Name is required.'; return; }
    if (this.form.frequency === 'weekly' && (!this.form.target || this.form.target < 1)) {
      this.formError = 'Weekly habits need a target ≥ 1.';
      return;
    }
    const payload = {
      name: this.form.name.trim(),
      category: this.form.category.trim(),
      frequency: this.form.frequency,
      ...(this.form.frequency === 'weekly' ? { target: this.form.target } : {})
    };
    if (this.mode === 'edit' && this.habit) {
      this.save.emit({ ...this.habit, ...payload });
    } else {
      this.save.emit(payload as Omit<Habit, 'id' | 'createdAt'>);
    }
  }

  doArchive() {
    if (!this.habit) return;
    if (!confirm('Archive this habit? Hidden from today, but kept in your history.')) return;
    this.archive.emit(this.habit.id);
    this.close.emit();
  }

  doUnarchive(habitId: string) { this.unarchive.emit(habitId); }
  doHardDelete(habit: Habit) {
    if (!confirm(`Permanently delete "${habit.name}" and all its completion records? This cannot be undone.`)) return;
    this.hardDelete.emit(habit.id);
  }
}
